import React, { ChangeEvent, useState, FC } from "react";
import {CircularProgress} from "@mui/material";
import styles from "./login.module.scss";
import { useNavigate } from 'react-router-dom';
import { login } from "../../apis/reducers/authReducer";
import { useDispatch } from "react-redux";
import { LOCALSTORAGE } from "../../libs/constants";

const Login: FC = () => {
  const dispatch: any = useDispatch();
  const navigate = useNavigate();
  const initialErrorValues = { emailError: "", passwordError: "" };
  const [formValues, setFormValues] = useState({ email: "", password: "" });
  const [formErrors, setFormErrors] = useState(initialErrorValues);
  const [isLoading, setIsLoading] = useState(false);

  // Stores values
  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setFormValues({ ...formValues, [name]: value });
  };

  const validate = (values: { email: string; password: string }) => {
    const errors = initialErrorValues;
    if (!values.email) {
      errors.emailError = "メールアドレスを入力してください";
    }
    if (!values.password) {
      errors.passwordError = "パスワードを入力してください";
    }
    return errors;
  };


  const handleSubmit = async(e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const errors = validate(formValues)
    setIsLoading(true);
    
    if (errors.emailError === '' && errors.passwordError === '') {
      dispatch(login(formValues)).unwrap()
        .then(() => navigate("/dashboard"))
        .catch((error: any) => {
          setIsLoading(false);
          setFormErrors({
            emailError: " ", passwordError: "メールアドレスかパスワードが間違っています"
          })
        })
    } else {
      setFormErrors(errors);
      setIsLoading(false);
    }
  };


  React.useEffect(() => {
    const token = localStorage.getItem(LOCALSTORAGE.token);
    if (token && token !== "") {
      navigate("dashboard")
    } 
  },[])

  return (
    <div className={styles.LoginPage}>
      <div className={styles.Login}>
        <img
          className={styles.TitleImg}
          src={`${process.env.PUBLIC_URL}/Logo.png`}
          alt="Logo"
        />
        <div className={styles.LoginTitle}>請求書管理システム</div>
        <form onSubmit={(e) => handleSubmit(e)}>
          <div className={!formErrors.emailError ? `${styles.MailForm}` : `${styles.MailForm} ${styles.warning}`}>
            <div>メールアドレス</div>
            <input
              name="email"
              value={formValues.email}
              onChange={(e) => handleChange(e)}
            />
          </div>
          <p className={styles.errorMsgMail}>{formErrors.emailError}</p>
          <div className={!formErrors.passwordError ? `${styles.PasswordForm}` : `${styles.PasswordForm} ${styles.warning}`}>
            <div>パスワード</div>
            <input
              type="password"
              name="password"
              value={formValues.password}
              onChange={(e) => handleChange(e)}
            />
          </div>
          <p className={styles.errorMsgPassword}>{formErrors.passwordError}</p>
          <button className={styles.LoginButton}>
            ログイン
          </button>
        </form>
        { isLoading ? <div className={styles.overlay}>
            <CircularProgress size={40} sx={{color:"#F4F6FA"}}/>
          </div> 
          : <></>}
      </div>
    </div>
  );
};

export default Login;